const { REACT_APP_ENV } = process.env;

// 接口Root
export const apiRoot=REACT_APP_ENV==='development'?'https://ccpd.devindata.com/api':'https://ccpd.devindata.com/api';

// 网站程序名称
export const webTitle='煤化工物性数据库';

// 应用权限登录名称
export const appLoginName='煤化工物性数据库';

const preFix='CCPD';//常数字段前缀

// 主题缓存字段名
export const themsField=`${preFix}_theme`;

// 用户信息缓存字段
export const userInfoField=`${preFix}_userInfo`;

export const themes=[
  {
    name:'浅色',
    code:'light'
  },
  {
    name:'暗色',
    code:'dark'
  },
]